import ltOrderMore from 'html/account/lt-order-more.html';
import App from 'app/app.js';

function LtOrderMoreDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onLoadSubject: '&',
      onCancellation: '&'
    },
    template: ltOrderMore,
    controller: 'LtOrderMoreDrawerCtrl',
    controllerAs: 'orderMoreDrawer'
  };
}

App.directive('ltOrderMoreDrawer', [LtOrderMoreDrawerDirective]);
